import type {
    PlaceholderValues,
} from '@touchnet/user-management';


const erpUiAssignableRoles = [
    'ERP_UI_ADMIN_USER',
];

const getScopesWithRoleCodes = (
    placeholders: PlaceholderValues[],
    roleCodes: string[]
): PlaceholderValues[] => placeholders.reduce((
    acc: PlaceholderValues[],
    phv: PlaceholderValues
): PlaceholderValues[] => [
    ...acc,
    ...roleCodes.reduce((
        acc2: PlaceholderValues[],
        roleCode: string
    ): PlaceholderValues[] => [...acc2, {...phv, roleCode}], []),
], []);

export const getFinalErpAdminScopes = (placeholders: PlaceholderValues[]): PlaceholderValues[] => {
  return getScopesWithRoleCodes(placeholders, erpUiAssignableRoles);
}
